import React from "react";
import { AppBarStyled, ToolbarStyled, IconButtonStyled, TypographyStyled } from "./Header.styles";
import { Menu as MenuIcon } from "@mui/icons-material";
import { HeaderMenu } from "../HeaderMenu";

interface HeaderProps {
  open: boolean;
  onDrawerOpen: () => void;
}

export default function Header({ open, onDrawerOpen }: HeaderProps) {
  return (
    <AppBarStyled position="absolute" open={open}>
      <ToolbarStyled>
        <IconButtonStyled
          open={open}
          edge="start"
          color="inherit"
          aria-label="open drawer"
          onClick={onDrawerOpen}
          sx={{
            marginRight: "36px",
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </IconButtonStyled>
        <TypographyStyled variant="h5" color="inherit" noWrap>
          MindSet
        </TypographyStyled>
        <HeaderMenu />
      </ToolbarStyled>
    </AppBarStyled>
  );
}
